<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g>
      <g style="opacity: 0"><rect x="0" y="0" width="16" height="16" rx="0" fill="currentColor" fill-opacity="1" /></g>
      <g>
        <path
          d="M1,5.581C1,6.27253,1.685092,6.75532,2.33634,6.52274L3.8,6L3.8,14C3.8,14.5523,4.24772,15,4.8,15L11.2,15C11.7523,15,12.2,14.5523,12.2,14L12.2,6L13.6637,6.52274C14.3149,6.75532,15,6.27253,15,5.581L15,3.20472C15,2.7821100000000003,14.7343,2.40512,14.3363,2.2629799999999998L10.8,1C9.28583,2.62233,6.71417,2.62233,5.2,1L1.663664,2.2629799999999998C1.265671,2.40512,1,2.7821100000000003,1,3.20472L1,5.581Z"
          fill="currentColor"
          fill-opacity="1"
        />
      </g>
    </g>
  </svg>
</template>
